import React from 'react';
const includes = [{
  number: '01',
  title: 'CÓDIGO ROJO — El Manual Maestro',
  description: '20 sensores invisibles en 3 fases. Auditas su carácter sin que él sepa que lo estás haciendo.'
}, {
  number: '02',
  title: 'Ficha de Evaluación de Campo',
  description: 'Checklist de respuesta rápida. Marca en tiempo real y obtén un veredicto frío.'
}, {
  number: '03',
  title: 'El Interrogatorio Invisible',
  description: '3 preguntas clave que revelan sus intenciones reales en una charla totalmente natural.'
}, {
  number: '04',
  title: 'La Tabla de Decisión Final',
  description: 'Verde, Amarillo o Rojo. Sin ambigüedad. La respuesta lógica a tu dilema emocional.'
}];
export function IncludesSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-106">
      <span className="inline-block bg-[var(--accent)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-107">
        QUÉ INCLUYE
      </span>

      <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-108">
        El sistema completo de detección.
      </h2>

      <div className="mt-5 bg-[var(--card)] rounded-2xl overflow-hidden border border-[var(--border)]" data-id="element-109">
        {includes.map((item, index) => <div key={index} className={`flex gap-4 items-start p-5 px-6 ${index < includes.length - 1 ? 'border-b border-[var(--red)]/15' : ''}`} data-id="element-110">
            <span className="text-[var(--red2)] text-xl font-black flex-shrink-0 mt-0.5 w-8" data-id="element-111">
              {item.number}
            </span>
            <div data-id="element-112">
              <h3 className="text-[15px] font-bold text-white mb-1" data-id="element-113">
                {item.title}
              </h3>
              <p className="text-[var(--muted)] text-[13px] leading-relaxed" data-id="element-114">
                {item.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}